(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').directive('apIncludeReplace', [
        apIncludeReplace,
    ]);

    function apIncludeReplace(
    ) {
        //ng-include places the included content inside of a div. Sometimes this affects styling.
        //This directive simply replaces the div with the contents of the div, effectively making ng-include
        //render the content inline instead of inside of a new div.

        var directive = {
            require: 'ngInclude',
            restrict: 'A',
            link: link,
        };

        return directive;

        function link(
            scope,
            el
        ) {
            // This used to be el.children(), but i changed it to el.contents()
            // because that is what ngInclude is $compile()-ing.
            // The difference is that contents() also includes text and comment nodes, and children() does not.
            el.replaceWith(el.contents());
        }
    }

})(window.angular);
